/* tslint:disable */
/* eslint-disable */
/**
 * REST API for AWV-UI
 * AWV-UI向けのREST APIリファレンス  ## Version履歴 - 1.0:2023/4/28 初版作成 - 1.1:2023/6/30   - すべてのAPIリファレンスを一つにまとめた   - Suspend Task→Cancel Taskに名前を変更   - 認証開始　削除   - トークン更新　認証処理の見直しにより全体修正   - タスク取得　レスポンスのユーザ名をユーザIDに変更、タスク状態修正   - Awrs→Awvsに修正   - 完成機情報取得　レスポンスに「カメラ仕様」「名称ID」追加、パラメータに車台形式・番号追加   - Go Home Task　レスポンスのtaskIDをjobsetId修正   - 以下API新規追加     - WebRTC配信設定     - WebRTC接続情報取得     - WebRTCユーザー設定     - パスワードリセット     - アンロックアカウント実行     - アンロックアカウントメール送信 - 1.2:2023/7/28   - 地図情報取得　パラメータのinをpathに修正   - タスク作成状況確認　パラメータの指定方法修正   - UnlockAccountResponseStatus204のref先変更   - 全APIにoperationId付与   - Skip Task　エラーレスポンス追加   - Cancel Task　エラーレスポンス追加   - プロジェクト一覧取得　レスポンスにジョブサイト名追加　400エラー削除   - トークン更新　レスポンスの204を削除し200を追加。レスポンスにemail、roleNameを追加   - タスク取得　レスポンス、リクエストパラメータ修正   - 完成機情報取得　正常レスポンス(200)の応答をobject形式に修正。処理概要に完成機1台分の情報取得の旨追記   - タスク作成状況確認　正常レスポンス(200)の応答をobject形式に修正   - タスク更新　リクエストをリクエストボディに変更し内容を修正。レスポンス修正   - タスク取得　正常レスポンス(200)の応答をobject形式に修正   - タスク名一覧取得　正常レスポンス(200)の応答をobject形式に修正   - WebRTC配信設定情報　正常レスポンス(200)の応答をobject形式に修正   - タスク登録　リクエストパラメータの内容修正   - タスク削除　リクエストパラメータの内容修正   - タスク作成状況確認　タスク作成時の409エラーを追加   - API設計方針追記 及び伴うエラーコードレスポンスをstringに修正   - マップ503エラーレスポンスの説明を500から503に修正   - 地図更新確認　リクエストパラメータの内容修正。200レスポンスの内容修正。204レスポンス削除。   - タスク登録　リクエストパラメータにfrom地点ノードの停止時間追加   - タスク更新　リクエストパラメータにfrom地点ノードの停止時間追加   - タスク名一覧取得　経由ノードのリストと、from地点ノードでの停止時間をレスポンスに追加。   - タスク取得　パラメータの必須かどうかを修正。経路情報取得の要否削除。レスポンスの必須かどうかを修正。   - タスク名一覧取得　レスポンス名をキャメルケースに修正し、配列でなくした。   - タスク承認　リクエストパラメータをキャメルケースに修正   - タスク取得　リクエストパラメータに「再計算タスク取得フラグ」を追加。レスポンスの必須かどうかを修正。   - WebRTC接続情報取得　レスポンスパラメータから「日時」を削除。「webRTC配信の停止」のパラメータ名を修正   - タスク作成状況確認　 レスポンスパラメータ名を修正 jobsetStatus → jobSetStatus   - Go Home Task、Cancel Task、Skip Taskを一つのタグにまとめた。   - パラメータ等にrequireで存在しないものが指定されているのを修正   - ResistTaskDataをRegisterTaskDataに修正   - 交通状況編集　レスポンス内容をバージョンIDのみに修正。204削除。   - Go Home Task実行 リクエストパラメータの日時情報候補リスト削除し、fromノードIDと開始希望日時追加。 - 1.3:2023/9/29   - Go Home Task実行　パラメータのrequireを修正   - WebRTC配信設定　「WebRTC解像度」と「WebRTCフレームレート」をrequireから外した   - 地図情報取得　レスポンスの地図情報の内容修正。204レスポンス削除。レスポンスに作成日時、更新日時、作成ユーザを追加。   - 交通状況編集　パラメータの地図情報をエッジ更新情報に修正   - 完成機情報取得　パラメータのgeoSiteId→jobSiteIdに修正。204レスポンス削除。   - usersに属するAPIから、AUTHORIZATIONS:PermissionTokenを削除   - タスク取得　Dateをdateにし、型も修正。レスポンスの「タスク実行予定時刻」の名称を「タスク実行予定時間（分）」に修正。レスポンスの経路情報にノードの到着時間と出発時間を追加。JobInfosの内部的な仕様修正。画面表示用タスクIDの例のスペル修正。レスポンスのバージョンIDに説明追加。   - 通知一覧取得　APIの説明文修正。パラメータの取得上限数の説明文修正、requireに指定、範囲を1～500に指定。レスポンスの通知情報内容修正。レスポンスに「車台形式・番号」追加404エラー追加。レスポンスに画面表示用タスクID追加。   - 通知既読　削除。   - 通知更新確認　APIの説明文修正。レスポンスの最新通知情報において、該当するイベントが0件だった場合未設定(null)とする旨を説明に追記及びレスポンスに「車台形式・番号」追加。レスポンスに画面表示用タスクID追加。   - プロジェクト一覧取得　ソートして返却する旨を記載   - トークン更新　レスポンスに名前、名字を追加   - jobsetStatus → jobSetStatusに修正   - メモ設定のpatternに空白文字追加 及び 1個以上ではなく0個以上に一致するよう修正   - タスク登録　パラメータのextensionTimeLoadをrequiredから外し、説明文を修正   - タスク更新　パラメータのextensionTimeLoadをrequiredから外した。   - タスク承認　リクエストボディをリスト化。   - タスク名一覧取得　JobInfosの内部的な仕様修正。extensionTimeLoadをrequiredから外した。   - WebRTCユーザー設定　200レスポンスを204に修正。   - WebRTC接続情報取得 200レスポンスの説明文修正。 - 1.4:2023/10/24   - 交通状況編集のレスポンスに最適化対象ジョブセットIDリストを追加   - タスク取得のパラメータに最適化対象ジョブセットIDリストを追加 - 1.4.1:2023/10/31   - タスク取得(一括承認用)APIを追加し、タスク取得APIから該当パラメータを削除 - 1.4.2:2023/11/08   - タスク取得(一括承認用)APIのリクエストパラメータを最適化対象ジョブセットIDからオブジェクトに修正   - 交通状況編集のレスポンスの最適化対象ジョブセットIDからオブジェクトに修正   - タスク取得APIのリクエストパラメータの地図バージョンを削除 - 1.4.3:2024/01/10   - タスク取得APIのレスポンスに移動タスク生成フラグを追加   - タスク登録APIのリクエストパラメータにタスク補完設定(移動タスク生成フラグ)を追加   - タスク取得APIのリクエストパラメータに承認待ちタスクのみ取得するフラグを追加   - 完成機情報取得のレスポンスの内容修正(conditionに「OTA中」を追加)   - 完成機情報取得のレスポンスに自律走行可否を追加 - 1.4.4:2024/01/23   - タスク取得のリクエストパラメータにパスデータを取得するか否かのフラグを追加   - タスク取得のレスポンスに経由パスのリストを追加   - プロジェクト一覧取得APIのレスポンスに地理サイト名と{ジョブサイトID, ジョブサイト名}を追加   - 地図情報取得APIのリクエストパラメータをジョブサイトIDから地図IDに変更   - 地図一覧取得APIを追加 - 1.4.5:2024/02/15   - 地図情報取得のレスポンスタイプMapEdgeTypeにoneWayを追加 - 1.5:2024/03/06   - 緊急停止実行APIを追加 - 1.6:2024/10/04   - 荷物情報取得APIを追加   - 充電器情報取得APIを追加 - 1.7:2024/10/17   - 充電運行計画のタスク登録APIを追加   - 充電運行計画のタスク更新APIを追加   - 充電運行計画のタスク取得APIを追加   - 充電運行計画のタスク名一覧取得APIを追加 - 1.8:2024/10/22   - ユーザー一覧取得APIを追加   - プロジェクト一覧取得のレスポンスに組織ID追加   - 充電運行計画のタスク名一覧取得のリクエストパラメータにinputDateを追加 - 1.8.1:2024/10/25   - 充電運行計画のタスク登録のリクエストパラメータにendDatetimeを追加   - 充電運行計画のタスク更新のリクエストパラメータにendDatetimeを追加 - 1.8.2:2024/11/07   - 充電運行計画のタスク名一覧取得のリクエストパラメータにjobSetIdを追加 - 1.8.3:2024/11/11   - 充電運行計画のタスク名一覧取得のレスポンスのjobInfosにjobIdを追加 - 1.8.4:2024/11/18   - 充電運行計画のタスク取得のレスポンスにバージョンIDを追加   - 充電運行計画のタスク名一覧取得のレスポンスにバージョンIDを追加 - 1.8.5:2024/11/21   - 充電運行計画のタスク登録／更新リクエストのジョブ終了希望日時のパラメータ名を修正 - 1.8.6:2024/11/22   - 充電運行計画のタスク取得のレスポンスに荷物数量を追加 - 1.8.7:2024/11/28   - 充電運行計画のタスク取得のレスポンスのjobPlanningEndDatetimeをrequiredから外した。  ## API設計方針 - 要求仕様: [API設計ガイドライン](https://hndx-gh-ex01.rd.honda.co.jp/OPPF-2X-DEV-COMMON-COMPONENTS/requirements/blob/master/api/api_design_guideline.md) - Description は APIの概要の記載にとどめ、初期値といった Swagger で用意されている記載方法がある場合はそれに則る書き方にする。 - OP-PFからのエラーレスポンスコードがある場合はintgerからstringに変換して返す。  上記を設計原則とするが、例外となるものは明記する。  ## Deprecated APIについて OP-PF AWV-UIにおいて、初期に利用されていたAPIをDeprecatedとして明示している。 - 新規での利用はしないこと。 - 実装のメンテナンスは行われず、テスト対象にもしない。 - 将来的に実装は取り除かれ、API仕様からも削除される 
 *
 * The version of the OpenAPI document: 1.8.6
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InputJobInfoMultipleCharge } from './InputJobInfoMultipleCharge';
import {
    InputJobInfoMultipleChargeFromJSON,
    InputJobInfoMultipleChargeFromJSONTyped,
    InputJobInfoMultipleChargeToJSON,
} from './InputJobInfoMultipleCharge';
import type { JobIdAndRequestedEndDatetimesInfo } from './JobIdAndRequestedEndDatetimesInfo';
import {
    JobIdAndRequestedEndDatetimesInfoFromJSON,
    JobIdAndRequestedEndDatetimesInfoFromJSONTyped,
    JobIdAndRequestedEndDatetimesInfoToJSON,
} from './JobIdAndRequestedEndDatetimesInfo';
import type { JobIdInfo } from './JobIdInfo';
import {
    JobIdInfoFromJSON,
    JobIdInfoFromJSONTyped,
    JobIdInfoToJSON,
} from './JobIdInfo';

/**
 * 
 * @export
 * @interface UpdateTaskDataMultipleCharge
 */
export interface UpdateTaskDataMultipleCharge {
    /**
     * ジョブセットID
     * @type {string}
     * @memberof UpdateTaskDataMultipleCharge
     */
    jobSetId: string;
    /**
     * ジョブセット名
     * @type {string}
     * @memberof UpdateTaskDataMultipleCharge
     */
    jobSetName?: string;
    /**
     * 地図ID
     * @type {string}
     * @memberof UpdateTaskDataMultipleCharge
     */
    mapId?: string;
    /**
     * 地図Ver
     * @type {number}
     * @memberof UpdateTaskDataMultipleCharge
     */
    mapVer?: number;
    /**
     * from地点ノードID
     * @type {number}
     * @memberof UpdateTaskDataMultipleCharge
     */
    fromNodeId?: number;
    /**
     * to地点ノードID
     * @type {number}
     * @memberof UpdateTaskDataMultipleCharge
     */
    toNodeId?: number;
    /**
     * 車台形式・番号のリスト
     * @type {Array<string>}
     * @memberof UpdateTaskDataMultipleCharge
     */
    frameTypeAndNumbers?: Array<string>;
    /**
     * 追加するジョブ情報のリスト
     * @type {Array<InputJobInfoMultipleCharge>}
     * @memberof UpdateTaskDataMultipleCharge
     */
    addJobInfos?: Array<InputJobInfoMultipleCharge>;
    /**
     * 更新するジョブ情報のリスト
     * @type {Array<JobIdAndRequestedEndDatetimesInfo>}
     * @memberof UpdateTaskDataMultipleCharge
     */
    updateJobInfos?: Array<JobIdAndRequestedEndDatetimesInfo>;
    /**
     * 削除するジョブ情報のリスト
     * @type {Array<JobIdInfo>}
     * @memberof UpdateTaskDataMultipleCharge
     */
    deleteJobInfos?: Array<JobIdInfo>;
    /**
     * 再登録する未処理ジョブ情報のリスト
     * 
     *  更新対象以外のジョブセットに紐づく未処理ジョブのみ指定可能。
     * @type {Array<JobIdAndRequestedEndDatetimesInfo>}
     * @memberof UpdateTaskDataMultipleCharge
     */
    untreatedJobInfos?: Array<JobIdAndRequestedEndDatetimesInfo>;
    /**
     * 
     * @type {Date}
     * @memberof UpdateTaskDataMultipleCharge
     */
    startDatetime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateTaskDataMultipleCharge
     */
    endDatetime?: Date;
    /**
     * ジョブ終了希望日時再設定フラグ
     * 
     *  ジョブ棄却時の挙動を設定する。
     * 
     *  Trueの場合、ジョブ棄却時にジョブ終了希望日時を再設定し、再計算を行う。
     * 
     *  再設定するジョブ終了希望日時は実行時間が決まった最後のジョブの開始時間以降、ジョブセット終了時間以内とする。 また、ジョブ終了希望日時の再設定は、リクエスト時にジョブ終了希望日時が設定されているジョブが対象となる。
     * @type {boolean}
     * @memberof UpdateTaskDataMultipleCharge
     */
    resetJobRequestedEndDatetime?: boolean;
    /**
     * メモ設定
     * @type {string}
     * @memberof UpdateTaskDataMultipleCharge
     */
    memo?: string;
    /**
     * 充電器IDのリスト
     * @type {Array<string>}
     * @memberof UpdateTaskDataMultipleCharge
     */
    chargerIds?: Array<string>;
    /**
     * 配送外に充電(夜間充電等)を行うかのフラグ
     * 
     *  指定しない場合は、defaultでFalseが設定される。
     * 
     *  配送外充電は、OPPF内で設定された時刻(例: 翌日の7時)まで行う。
     * @type {boolean}
     * @memberof UpdateTaskDataMultipleCharge
     */
    chargeOutsideDelivery?: boolean;
    /**
     * バージョンID
     * @type {string}
     * @memberof UpdateTaskDataMultipleCharge
     */
    versionId: string;
}

/**
 * Check if a given object implements the UpdateTaskDataMultipleCharge interface.
 */
export function instanceOfUpdateTaskDataMultipleCharge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jobSetId" in value;
    isInstance = isInstance && "versionId" in value;

    return isInstance;
}

export function UpdateTaskDataMultipleChargeFromJSON(json: any): UpdateTaskDataMultipleCharge {
    return UpdateTaskDataMultipleChargeFromJSONTyped(json, false);
}

export function UpdateTaskDataMultipleChargeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTaskDataMultipleCharge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jobSetId': json['jobSetId'],
        'jobSetName': !exists(json, 'jobSetName') ? undefined : json['jobSetName'],
        'mapId': !exists(json, 'mapId') ? undefined : json['mapId'],
        'mapVer': !exists(json, 'mapVer') ? undefined : json['mapVer'],
        'fromNodeId': !exists(json, 'fromNodeId') ? undefined : json['fromNodeId'],
        'toNodeId': !exists(json, 'toNodeId') ? undefined : json['toNodeId'],
        'frameTypeAndNumbers': !exists(json, 'frameTypeAndNumbers') ? undefined : json['frameTypeAndNumbers'],
        'addJobInfos': !exists(json, 'addJobInfos') ? undefined : ((json['addJobInfos'] as Array<any>).map(InputJobInfoMultipleChargeFromJSON)),
        'updateJobInfos': !exists(json, 'updateJobInfos') ? undefined : ((json['updateJobInfos'] as Array<any>).map(JobIdAndRequestedEndDatetimesInfoFromJSON)),
        'deleteJobInfos': !exists(json, 'deleteJobInfos') ? undefined : ((json['deleteJobInfos'] as Array<any>).map(JobIdInfoFromJSON)),
        'untreatedJobInfos': !exists(json, 'untreatedJobInfos') ? undefined : ((json['untreatedJobInfos'] as Array<any>).map(JobIdAndRequestedEndDatetimesInfoFromJSON)),
        'startDatetime': !exists(json, 'startDatetime') ? undefined : (new Date(json['startDatetime'])),
        'endDatetime': !exists(json, 'endDatetime') ? undefined : (new Date(json['endDatetime'])),
        'resetJobRequestedEndDatetime': !exists(json, 'resetJobRequestedEndDatetime') ? undefined : json['resetJobRequestedEndDatetime'],
        'memo': !exists(json, 'memo') ? undefined : json['memo'],
        'chargerIds': !exists(json, 'chargerIds') ? undefined : json['chargerIds'],
        'chargeOutsideDelivery': !exists(json, 'chargeOutsideDelivery') ? undefined : json['chargeOutsideDelivery'],
        'versionId': json['versionId'],
    };
}

export function UpdateTaskDataMultipleChargeToJSON(value?: UpdateTaskDataMultipleCharge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jobSetId': value.jobSetId,
        'jobSetName': value.jobSetName,
        'mapId': value.mapId,
        'mapVer': value.mapVer,
        'fromNodeId': value.fromNodeId,
        'toNodeId': value.toNodeId,
        'frameTypeAndNumbers': value.frameTypeAndNumbers,
        'addJobInfos': value.addJobInfos === undefined ? undefined : ((value.addJobInfos as Array<any>).map(InputJobInfoMultipleChargeToJSON)),
        'updateJobInfos': value.updateJobInfos === undefined ? undefined : ((value.updateJobInfos as Array<any>).map(JobIdAndRequestedEndDatetimesInfoToJSON)),
        'deleteJobInfos': value.deleteJobInfos === undefined ? undefined : ((value.deleteJobInfos as Array<any>).map(JobIdInfoToJSON)),
        'untreatedJobInfos': value.untreatedJobInfos === undefined ? undefined : ((value.untreatedJobInfos as Array<any>).map(JobIdAndRequestedEndDatetimesInfoToJSON)),
        'startDatetime': value.startDatetime === undefined ? undefined : (value.startDatetime.toISOString()),
        'endDatetime': value.endDatetime === undefined ? undefined : (value.endDatetime.toISOString()),
        'resetJobRequestedEndDatetime': value.resetJobRequestedEndDatetime,
        'memo': value.memo,
        'chargerIds': value.chargerIds,
        'chargeOutsideDelivery': value.chargeOutsideDelivery,
        'versionId': value.versionId,
    };
}

